import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useParentContext } from "./context/ParentContext";

const RootLayout = ({ setLoading, setCurrentUser, setUserRole }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setParentState } = useParentContext();

  useEffect(() => {
    const initSession = async () => {
      const path = location.pathname;
      console.log("Current path:", path);
      const isPublicPath =
        path.includes("/parent-add-child") ||
        path.includes("/doctor-add-child");

      if (isPublicPath) {
        console.log("Public route, skipping auth...");
        setLoading(false);
        return;
      }
      setLoading(true);
      const refreshToken = localStorage.getItem("s2srefresh");
      try {
        // Step 1: Refresh the access token
        const refreshRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/refresh`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${refreshToken}`, // ✅ use REFRESH token here
            },
          }
        );
        const refreshData = await refreshRes.json();
        console.log("Refresh response:", refreshData);

        if (!refreshRes.ok || refreshData.success === false) {
          localStorage.removeItem("s2stoken");
          localStorage.removeItem("s2srefresh");
          setCurrentUser(null);
          setUserRole(null);
          navigate("/");
          return;
        }

        // Step 2: Save new access token
        localStorage.setItem("s2stoken", refreshData.access_token);

        // Step 3: Use new access token to fetch user profile
        const sessionRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/profile`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${refreshData.access_token}`,
            },
          }
        );

        if (sessionRes.ok) {
          const data = await sessionRes.json();
          setCurrentUser(data.user);
          setUserRole(data.user_type);
          if (data.user_type === "parent") {
            setParentState(data.user);
          }
        } else {
          setCurrentUser(null);
          setUserRole(null);
        }
      } catch (error) {
        console.error("Error during session init:", error);
        setCurrentUser(null);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    initSession();
  }, [location.pathname]);
  return <Outlet />;
};
export default RootLayout;
